import { useEffect, useState } from "react";
import "./Stripe.css";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import { loadStripe } from "@stripe/stripe-js";
import { API_CHECKOUT } from "../../../utils/constants";
import useAddressHook from "../../../hook/useAddressHook";

function Payment({
  setSuccessPayment,
  price,
  setPaymentInfo,
  setStartCall,
  setTypeCreditCard,
  formData,
  typeUser,
  cityOption,
  countryOption,
}) {
  const [stripePromise, setStripePromise] = useState(null);
  const [clientSecret, setClientSecret] = useState("");
  const [amount, setAmount] = useState(price);

  const appearance = {
    theme: "stripe",
  };

  useEffect(() => {
    fetch(`${API_CHECKOUT}config`).then(async (r) => {
      //fetch("/config").then(async (r) => {
      const { publishableKey } = await r.json();
      setStripePromise(loadStripe(publishableKey));
    });
  }, []);

  const getAmountStripe = (amount) => {
    const roundedAmount = parseFloat(amount).toFixed(2);
    const amountStripe = Math.round(roundedAmount * 100);
    return amountStripe;
  };

  useEffect(() => {
    const amountStripe = getAmountStripe(amount);
    const getCityNameById = (cityId) => {
      const city = cityOption.find(
        (option) => option.id.toString() === cityId.toString()
      );
      return city ? city.name : "";
    };

    const getCountryNameById = (countryId) => {
      const country = countryOption.find(
        (option) => option.id.toString() === countryId.toString()
      );
      return country ? country.country_iso_code : "";
    };

    const cityName = getCityNameById(formData?.city?.toString());
    const countryName = getCountryNameById(formData?.country?.toString());

    console.log("City Name Payment:", cityName);
    console.log("Country Name Payment:", countryName);

    const email = formData.email;
    const name =
      typeUser === "company"
        ? formData.companyname
        : `${formData.firstname} ${formData.lastname}`;
    const address = {
      city: cityName,
      country: countryName,
      line1: formData.address,
      line2: formData.address,
      postal_code: formData.postalcode,
      state: formData.province,
    };

    console.log("create-payment-intent", email, name, address);

    fetch(`${API_CHECKOUT}create-payment-intent`, {
      //fetch("/create-payment-intent", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amountStripe,
        email: email,
        name: name,
        address: address,
      }),
    }).then(async (result) => {
      var { clientSecret } = await result.json();
      setClientSecret(clientSecret);
    });
  }, []);

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      {clientSecret && stripePromise && (
        <Elements stripe={stripePromise} options={{ clientSecret, appearance }}>
          <CheckoutForm
            setSuccessPayment={setSuccessPayment}
            setPaymentInfo={setPaymentInfo}
            setStartCall={setStartCall}
            setTypeCreditCard={setTypeCreditCard}
          />
        </Elements>
      )}
    </div>
  );
}

export default Payment;
